import {
  DefaultSequenceConditions,
  DefaultSequenceQuestSlug,
  LocationVarKey,
  SequenceSubType,
  SequenceInterface,
  SequenceType,
} from "@swivl-mono/types";
import { Button, ButtonColor } from "@swivl-mono/ui";
import _ from "lodash";
import { useEffect, useState } from "react";

import ModalModel from "../../../../Models/Modal/Modal.Model";
import SequencesModel from "../../../../Models/Sequences/SequencesModel";

export function SequenceCreateModal() {
  const { sequences } = SequencesModel.useState();
  const [type, setType] = useState<SequenceType | undefined>(undefined);
  useEffect(() => {
    SequencesModel.load(false);
  }, []);
  if (!sequences) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {!type && (
        <div>
          <h3>Select Type</h3>
          <div className="flex flex-col">
            <Button className="mt-1" color={ButtonColor.WHITE} onClick={() => setType(SequenceType.ABANDONED_CART)}>
              Abandoned Cart
            </Button>
            <Button className="mt-1" color={ButtonColor.WHITE} onClick={() => setType(SequenceType.PAST_DUE)}>
              Past Due
            </Button>
            <Button className="mt-1" color={ButtonColor.WHITE} onClick={() => setType(SequenceType.MOVE_IN)}>
              Move In
            </Button>
            <Button className="mt-1" color={ButtonColor.WHITE} onClick={() => setType(SequenceType.MOVE_OUT)}>
              Move Out
            </Button>
          </div>
        </div>
      )}
      {type === SequenceType.ABANDONED_CART && (
        <div>
          <h3>Past Due</h3>
          <SequenceCreateModalItem
            title={"Abandoned Cart 1 Day Ago"}
            type={SequenceType.ABANDONED_CART}
            subType={SequenceSubType.ABANDONED_CART_DAY_01}
            sequences={sequences}

            questSlug={DefaultSequenceQuestSlug[SequenceSubType.ABANDONED_CART_DAY_01]}
          />
          <SequenceCreateModalItem
            title={"Abandoned Cart 2 Days Ago"}
            type={SequenceType.ABANDONED_CART}
            subType={SequenceSubType.ABANDONED_CART_DAY_02}
            sequences={sequences}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.ABANDONED_CART_DAY_02]}
          />
          <SequenceCreateModalItem
            title={"Abandoned Cart 3 Days Ago"}
            type={SequenceType.ABANDONED_CART}
            subType={SequenceSubType.ABANDONED_CART_DAY_03}
            sequences={sequences}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.ABANDONED_CART_DAY_03]}
          />
          <SequenceCreateModalItem
            title={"Abandoned Cart 5 Days Ago"}
            type={SequenceType.ABANDONED_CART}
            subType={SequenceSubType.ABANDONED_CART_DAY_05}
            sequences={sequences}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.ABANDONED_CART_DAY_05]}
          />
          <SequenceCreateModalItem
            title={"Abandoned Cart 7 Days Ago"}
            type={SequenceType.ABANDONED_CART}
            subType={SequenceSubType.ABANDONED_CART_DAY_07}
            sequences={sequences}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.ABANDONED_CART_DAY_07]}
          />
          <SequenceCreateModalItem
            title={"Abandoned Cart 10 Days Ago"}
            type={SequenceType.ABANDONED_CART}
            subType={SequenceSubType.ABANDONED_CART_DAY_10}
            sequences={sequences}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.ABANDONED_CART_DAY_10]}
          />
          <SequenceCreateModalItem
            title={"Abandoned Cart 14 Days Ago"}
            type={SequenceType.ABANDONED_CART}
            subType={SequenceSubType.ABANDONED_CART_DAY_14}
            sequences={sequences}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.ABANDONED_CART_DAY_14]}
          />
          <SequenceCreateModalItem
            title={"Abandoned Cart 30 Days Ago"}
            type={SequenceType.ABANDONED_CART}
            subType={SequenceSubType.ABANDONED_CART_DAY_30}
            sequences={sequences}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.ABANDONED_CART_DAY_30]}
          />
          <Button color={ButtonColor.WHITE} onClick={() => ModalModel.hideModal()}>
            Done
          </Button>
        </div>
      )}

      {type === SequenceType.PAST_DUE && (
        <div>
          <h3>Past Due</h3>
          <SequenceCreateModalItem
            title={"On Due Date"}
            type={SequenceType.PAST_DUE}
            subType={SequenceSubType.PAST_DUE_DAY_00}

            sequences={sequences}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.PAST_DUE_DAY_00]}
          />
          <SequenceCreateModalItem
            title={"1 Day Past Due"}
            type={SequenceType.PAST_DUE}
            subType={SequenceSubType.PAST_DUE_DAY_01}

            sequences={sequences}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.PAST_DUE_DAY_01]}
          />
          <SequenceCreateModalItem
            title={"2 Days Past Due"}
            type={SequenceType.PAST_DUE}
            sequences={sequences}
            subType={SequenceSubType.PAST_DUE_DAY_02}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.PAST_DUE_DAY_02]}
          />
          <SequenceCreateModalItem
            title={"3 Days Past Due"}
            type={SequenceType.PAST_DUE}
            sequences={sequences}
            subType={SequenceSubType.PAST_DUE_DAY_03}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.PAST_DUE_DAY_03]}
          />
          <SequenceCreateModalItem
            title={"5 Days Past Due"}
            type={SequenceType.PAST_DUE}
            sequences={sequences}
            subType={SequenceSubType.PAST_DUE_DAY_05}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.PAST_DUE_DAY_05]}
          />
          <SequenceCreateModalItem
            title={"7 Days Past Due"}
            type={SequenceType.PAST_DUE}
            sequences={sequences}
            subType={SequenceSubType.PAST_DUE_DAY_07}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.PAST_DUE_DAY_07]}
          />
          <SequenceCreateModalItem
            title={"10 Days Past Due"}
            type={SequenceType.PAST_DUE}
            sequences={sequences}
            subType={SequenceSubType.PAST_DUE_DAY_10}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.PAST_DUE_DAY_10]}
          />
          <SequenceCreateModalItem
            title={"14 Days Past Due"}
            type={SequenceType.PAST_DUE}
            sequences={sequences}
            subType={SequenceSubType.PAST_DUE_DAY_14}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.PAST_DUE_DAY_14]}
          />
          <SequenceCreateModalItem
            title={"30 Days Past Due"}
            type={SequenceType.PAST_DUE}
            sequences={sequences}
            subType={SequenceSubType.PAST_DUE_DAY_30}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.PAST_DUE_DAY_30]}
          />
          <SequenceCreateModalItem
            title={"45 Days Past Due"}
            type={SequenceType.PAST_DUE}
            sequences={sequences}
            subType={SequenceSubType.PAST_DUE_DAY_45}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.PAST_DUE_DAY_45]}
          />
          <Button color={ButtonColor.WHITE} onClick={() => ModalModel.hideModal()}>
            Done
          </Button>
        </div>
      )}

      {type === SequenceType.MOVE_IN && (
        <div>
          <h3>Move In</h3>
          <SequenceCreateModalItem
            title={"At Move In"}
            type={SequenceType.MOVE_IN}
            sequences={sequences}
            subType={SequenceSubType.MOVE_IN_DAY_00}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_IN_DAY_00]}
          />
          <SequenceCreateModalItem
            title={"1 Day After Move In"}
            type={SequenceType.MOVE_IN}
            sequences={sequences}
            subType={SequenceSubType.MOVE_IN_DAY_01}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_IN_DAY_01]}
          />
          {/* <SequenceCreateModalItem
            title={"2 Days After Move In"}
            type={SequenceType.MOVE_IN}
            sequences={sequences}
            subType={SequenceSubType.MOVE_IN_DAY_02}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_IN_DAY_02]}
          /> */}
          <SequenceCreateModalItem
            title={"3 Days After Move In"}
            type={SequenceType.MOVE_IN}
            sequences={sequences}
            subType={SequenceSubType.MOVE_IN_DAY_03}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_IN_DAY_03]}
          />
          <SequenceCreateModalItem
            title={"5 Days After Move In"}
            type={SequenceType.MOVE_IN}
            sequences={sequences}
            subType={SequenceSubType.MOVE_IN_DAY_05}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_IN_DAY_05]}
          />
          <SequenceCreateModalItem
            title={"7 Days After Move In"}
            type={SequenceType.MOVE_IN}
            sequences={sequences}
            subType={SequenceSubType.MOVE_IN_DAY_07}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_IN_DAY_07]}
          />
          <SequenceCreateModalItem
            title={"10 Days After Move In"}
            type={SequenceType.MOVE_IN}
            sequences={sequences}
            subType={SequenceSubType.MOVE_IN_DAY_10}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_IN_DAY_10]}
          />
          <SequenceCreateModalItem
            title={"14 Days After Move In"}
            type={SequenceType.MOVE_IN}
            sequences={sequences}
            subType={SequenceSubType.MOVE_IN_DAY_14}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_IN_DAY_14]}
          />
          <SequenceCreateModalItem
            title={"30 Days After Move In"}
            type={SequenceType.MOVE_IN}
            sequences={sequences}
            subType={SequenceSubType.MOVE_IN_DAY_30}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_IN_DAY_30]}
          />
          <SequenceCreateModalItem
            title={"90 Days After Move In"}
            type={SequenceType.MOVE_IN}
            sequences={sequences}
            subType={SequenceSubType.MOVE_IN_DAY_90}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_IN_DAY_90]}
          />
          <Button color={ButtonColor.WHITE} onClick={() => ModalModel.hideModal()}>
            Done
          </Button>
        </div>
      )}

      {type === SequenceType.MOVE_OUT && (
        <div>
          <h3>Move Out</h3>
          <SequenceCreateModalItem
            title={"At Move Out"}
            type={SequenceType.MOVE_OUT}
            sequences={sequences}
            subType={SequenceSubType.MOVE_OUT_DAY_00}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_OUT_DAY_00]}
          />
          <SequenceCreateModalItem
            title={"1 Day After Move Out"}
            type={SequenceType.MOVE_OUT}
            sequences={sequences}
            subType={SequenceSubType.MOVE_OUT_DAY_01}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_OUT_DAY_01]}
          />
          {/* <SequenceCreateModalItem
            title={"2 Days After Move Out"}
            type={SequenceType.MOVE_OUT}
            sequences={sequences}
            subType={SequenceSubType.MOVE_OUT_DAY_02}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_OUT_DAY_02]}
          /> */}
          <SequenceCreateModalItem
            title={"3 Days After Move Out"}
            type={SequenceType.MOVE_OUT}
            sequences={sequences}
            subType={SequenceSubType.MOVE_OUT_DAY_03}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_OUT_DAY_03]}
          />
          <SequenceCreateModalItem
            title={"5 Days After Move Out"}
            type={SequenceType.MOVE_OUT}
            sequences={sequences}
            subType={SequenceSubType.MOVE_OUT_DAY_05}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_OUT_DAY_05]}
          />
          <SequenceCreateModalItem
            title={"7 Days After Move Out"}
            type={SequenceType.MOVE_OUT}
            sequences={sequences}
            subType={SequenceSubType.MOVE_OUT_DAY_07}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_OUT_DAY_07]}
          />
          <SequenceCreateModalItem
            title={"10 Days After Move Out"}
            type={SequenceType.MOVE_OUT}
            sequences={sequences}
            subType={SequenceSubType.MOVE_OUT_DAY_10}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_OUT_DAY_10]}
          />
          <SequenceCreateModalItem
            title={"14 Days After Move Out"}
            type={SequenceType.MOVE_OUT}
            sequences={sequences}
            subType={SequenceSubType.MOVE_OUT_DAY_14}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_OUT_DAY_14]}
          />
          <SequenceCreateModalItem
            title={"30 Days After Move Out"}
            type={SequenceType.MOVE_OUT}
            sequences={sequences}
            subType={SequenceSubType.MOVE_OUT_DAY_30}
            questSlug={DefaultSequenceQuestSlug[SequenceSubType.MOVE_OUT_DAY_30]}
          />
          <Button color={ButtonColor.WHITE} onClick={() => ModalModel.hideModal()}>
            Done
          </Button>
        </div>
      )}
      <div></div>
    </div>
  );
}

function SequenceCreateModalItem(props: {
  type: SequenceType;
  title: string;
  sequences: { [sequenceId: string]: SequenceInterface };
  subType: SequenceSubType;
  questSlug?: string;
}) {
  const exists = Object.values(props.sequences).some((sequence) => sequence.subType === props.subType);
  return (
    <div className="flex flex-row p-2  bg-orange-100 mb-2 items-middle">
      <b className="flex-1 flex items-center">{props.title}</b>
      {!exists && (
        <Button
          color={ButtonColor.ORANGE}
          onClickAsync={async () => {
            await SequencesModel.createSequence(props.title, props.type, props.subType, props.questSlug || "");
          }}
        >
          Add
        </Button>
      )}
    </div>
  );
}
